module.exports = __webpack_public_path__ + "media/s2Part1Model3.88106235.mp4";